export function isWeixin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}
export function isZonglan() {
    return /(hbxw)/i.test(navigator.userAgent);
}

export function isHbrb() {
    return /(hbxw)/i.test(navigator.userAgent);
}

export function isMobile() {
    return /Android|iPhone|iPad|iPod|Windows Phone|Mobile/i.test(navigator.userAgent);
}

//来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
export function getClientId() {
    if (isWeixin()) {
        return 2; //微信端
    } else if (isZonglan()) {
        return 3; //纵览客户端
    } else if (isHbrb()) {
        return 4; //河北日报客户端
    } else {
        return 5; //H5端
    }
}